import styled from 'styled-components';
import spacing from '@decisiv/design-tokens/lib/spacing';
import rem from 'polished/lib/helpers/rem';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';

export const HeaderBlock = styled(Flex).attrs({
  alignItems: 'flex-start',
  padding: 2,
})`
  background-color: ${toColorString(color.base.snowWhite)};
`;

export const HalfMoonBg = styled(Flex).attrs({
  flexDirection: 'column',
  flexWrap: 'wrap',
  paddingTop: 2,
  paddingBottom: 2,
})`
  background-color: ${toColorString(color.base.halfMoon)};
`;

export const EnableIntegration = styled(Flex).attrs({
  flexDirection: 'column',
  flexWrap: 'no-wrap',
  padding: 2,
  marginBottom: 2,
})`
  background-color: ${toColorString(color.base.fullMoon)};
`;

export const RemoveIntegration = styled(Flex).attrs({
  flexDirection: 'column',
  flexWrap: 'no-wrap',
  padding: 2,
})`
  background-color: ${toColorString(color.base.snowWhite)};
`;

export const SharedSettingsSection = styled(Flex).attrs({
  flexDirection: 'column',
  flexWrap: 'no-wrap',
  padding: 2,
  marginBottom: 2,
})`
  background-color: ${toColorString(color.base.snowWhite)};
`;

export const SharedSettingGroup = styled(Flex).attrs({
  flexDirection: 'column',
  marginTop: 1,
})`
  border-left: 2px solid ${toColorString(color.base.fullMoon)};
  padding-left: ${rem(spacing.base * 0.75)};
`;

export const Bold = styled.span`
  font-weight: bold;
  margin-left: ${rem(spacing.base * 0.3)};
  text-transform: capitalize;
`;

export const LocationContainer = styled(Flex)`
  padding: 1.25rem;
  margin-top: 1rem;
  background: ${toColorString(color.base.snowWhite)};
  flex-direction: column;
`;

// Reports the Shared Settings cascade as a section of the page rather than a
// coloured banner: the outcome is read like the locations list it mirrors, and a
// group of nine peers has to fit without pushing the form off-screen.
export const CascadeSection = styled(Flex).attrs({
  flexDirection: 'column',
  marginBottom: 2,
})`
  background-color: ${toColorString(color.base.snowWhite)};
  border: 1px solid ${toColorString(color.base.halfMoon)};
  border-radius: ${rem(spacing.base * 0.3)};
  padding: ${rem(spacing.base)} ${rem(spacing.base * 1.5)};
`;

// A partner integration in the Shared Settings panel, with where this location
// currently stands in it pushed to the right.
export const PartnerRow = styled(Flex).attrs({
  alignItems: 'center',
  justifyContent: 'space-between',
})`
  gap: ${rem(spacing.base * 0.5)};
  margin-top: ${rem(spacing.base * 0.25)};
`;

// The lifecycle-sync opt-out, closing the Shared Settings section it qualifies:
// a location can deviate from its group without unlinking it.
export const SyncOptOut = styled(Flex).attrs({
  flexDirection: 'column',
  marginTop: 2,
})`
  border-top: 1px solid ${toColorString(color.base.halfMoon)};
  padding-top: ${rem(spacing.base)};
  gap: ${rem(spacing.base * 0.25)};
`;

// The linked integrations a removal will also wipe, shown before it cascades.
// No fill: the table inside brings its own surface, and a card floating on a
// tinted panel reads as two competing blocks. The rule plus the modal's danger
// intent carry the warning.
export const AffectedList = styled(Flex).attrs({
  flexDirection: 'column',
  marginTop: 1,
})`
  border-left: 3px solid ${toColorString(color.status.danger.medium)};
  padding-left: ${rem(spacing.base)};
`;
